import React, { memo } from "react";
import domain from "../../../reusecomponent/domain";
import { ErrorToastContainer, SuccessToastContainer } from "../../function/CustomFunction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate } from "@fortawesome/free-solid-svg-icons";
import { getToken } from "../../function/token";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";

function SyncTemplate({setloder,setTempalate,userid}) {
    const Accesstoken = useSelector((state) => state.Token.value);
    const Sync = ()=> {
        setloder(true);
        const myHeaders = new Headers();
        const access_token = getToken();
        myHeaders.append("Authorization", `Bearer ${access_token}`);
    
        const requestOptions = {
        method: "GET",
        headers: myHeaders,
        };
        const user_roll = jwtDecode(Accesstoken);
        const url = user_roll.user_roll === 'Admin' ? `${domain()}/sync-template/${userid}` : `${domain()}/sync-template`;
        fetch(url, requestOptions)
        .then((response) => response.json())
        .then((result) => {
            setloder(false);
            if(result.status){
            setTempalate(result.data);
            SuccessToastContainer(result.message);
            }else{
            ErrorToastContainer(result.message);
            }          
        })
        .catch((error) => {
            setloder(false);
            ErrorToastContainer('Internal Server Error');
        });
    };

    return (
        <FontAwesomeIcon 
            title="Sync Template" 
            className="text-primary" 
            icon={faRotate} 
            style={{cursor: 'pointer', fontSize: '1.2rem'}} 
            onClick={Sync}
        />
    );
}

export default memo(SyncTemplate);
